import { useDispatch, useSelector } from 'react-redux';
import useLocalStore from '../../../hooks/useLocalStore';
import FJActionImageEnhancer from '../../../redux/action/FJActionImageEnhancer';
import { setSliceIsDraggingFileAction } from '../../../redux/slices/FJSliceCommon';
import FJUtil from '../../../util/FJUtil';
import FJActionEditPage from '../../../redux/action/FJActionEditPage.js';
import FJImageInput from '../../../common/components/FJImageInput/FJImageInput.jsx';
import { UPLOAD_FILE_TYPE_NO_GIF } from '../../../config/dataConfig/FJGenerateData.js';

const FJImageEnhancerInputContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const isDraggingFile = useSelector(state => state.common.isDraggingFile);
    const taskStatus = useSelector(state => state.common.taskStatus);

    const uploadImages = files => {
        dispatch(FJActionImageEnhancer.uploadImagesAction(files));
    };

    const _openMediaLibrary = () => {
        dispatch(FJActionEditPage.openMediaLibraryAction({ canMultipleChoose: true }));
    };
    const _setIsDraggingFile = value => {
        dispatch(setSliceIsDraggingFileAction(value));
    };
    const isDisabled = FJUtil.isGeneratingStatus(taskStatus);
    return (
        <FJImageInput
            isDraggingFile={isDraggingFile}
            openMediaLibrary={_openMediaLibrary}
            uploadImg={uploadImages}
            setIsDraggingFile={_setIsDraggingFile}
            disable={isDisabled}
            isMultiple={true}
            acceptFile={UPLOAD_FILE_TYPE_NO_GIF}
        />
    );
};
export default FJImageEnhancerInputContainer;
